import { render, staticRenderFns } from "./PreviewContentChooserDialog.vue?vue&type=template&id=1772e5a5&"
import script from "./PreviewContentChooserDialog.vue?vue&type=script&lang=ts&"
export * from "./PreviewContentChooserDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewContentChooserDialog.vue?vue&type=style&index=0&id=1772e5a5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports